import { connect } from 'react-redux'
import InviteesDialog from './invitees-dialog'

import {
  closeInviteesDialog,
  fetchAssessmentFileInvitees
} from '../../../stores/assessment-file/assessment-file.actions'
import {
  getInviteesDialog,
  getInviteesList,
  fetchInviteesRequest
} from '../../../stores/assessment-file/assessment-file.selectors'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const dialog = getInviteesDialog(state)
  const fetchRequest = fetchInviteesRequest(state)
  return {
    isOpen: dialog.opened,
    id: dialog.id,
    invitees: getInviteesList(state),
    pending: fetchRequest.pending
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: id => dispatch(fetchAssessmentFileInvitees(id)).catch(errorHandler),
  onClose: () => dispatch(closeInviteesDialog())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InviteesDialog)
